import React from "react";
import Box from "ReusableComponents/Box";
import { COLORS, SIZES, WEIGHT } from "theme";
import Text from "ReusableComponents/Text";
import { HOST } from "api/apiClient";

const FeatureInfo = ({ list, small }) => {
  return (
    <Box display="flex" check>
      <Box
        display="flex"
        marginTop={SIZES.fortyEight}
        flexDirection="column"
        w={small ? "100%" : "601px"}
      >
        {list.map(({ id, title, desc, alt, img }) => (
          <Box display="flex" key={id} marginBottom={"36px"}>
            <Box
              w={small ? SIZES.forty : "64px"}
              h={small ? SIZES.forty : "64px"}
              background={COLORS.primary}
              borderRadius="50%"
              b="none"
              display="flex"
              justifyContent="center"
              alignItems="center"
              key={id}
              padding={"5px"}
            >
              <img
                src={HOST + img}
                alt={alt}
                style={{
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              marginLeft="20px"
              alignItems="center"
              justifyContent="center"
              maxWidth="501px"
            >
              <Text
                fontSize={small ? SIZES.sizteen : SIZES.twentyFour}
                fontWeight={WEIGHT.bold}
                textColor={COLORS.white}
                margin={SIZES.zero}
              >
                {title}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FeatureInfo;
